var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbars',{attrs:{"objects":_vm.objects,"transition":"scroll-y-transition"},on:{"update:objects":function($event){_vm.objects=$event}},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var close = ref.close;
return [_c('BaseButtonIcon',{on:{"click":function($event){return close()}}},[_c('Icon',{attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.svgClose))])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }